import { ReactNode } from 'react';

import { FileUploadFn, GetFileDownloadUrlFn, SchemableFormFileUploadContext } from './SchemableFormFileUploadContext';

export const SchemableFormFileUploadContextProvider = ({
  uploadFile,
  getFileDownloadUrl,
  children,
}: {
  uploadFile: FileUploadFn;
  getFileDownloadUrl: GetFileDownloadUrlFn;
  children: ReactNode;
}) => {
  return (
    <SchemableFormFileUploadContext.Provider value={{ uploadFile, getFileDownloadUrl }}>
      {children}
    </SchemableFormFileUploadContext.Provider>
  );
};
